class AgeGate {
    constructor() {
        this.ageGate = document.querySelector('.age-gate')
        this.yesButton = this.ageGate.querySelector('button[class="age-gate__button"]')
        this.hasSeenAgeGate = localStorage.getItem('hasSeenAgeGate') === 'true'
        
        this.init()
    }

    init() {
        console.log(this.hasSeenAgeGate);

        if (this.hasSeenAgeGate) {
            this.hideAgeGate()
            return
        }

        this.showAgeGate()
        this.setupEventListeners()
    }

    showAgeGate() {
        this.ageGate.style.display = 'flex'
        document.body.style.overflow = 'hidden'
        this.setInert(true)
    }

    hideAgeGate() {
        this.ageGate.style.display = 'none'
        document.body.style.overflow = ''
        this.setInert(false)
        localStorage.setItem('hasSeenAgeGate', 'true')
    }

    setInert(shouldBeInert) {
        // Make all siblings of age gate inert when modal is shown
        const siblings = Array.from(document.body.children).filter(
            child => child !== this.ageGate
        )
        siblings.forEach(sibling => {
            if (shouldBeInert) {
                sibling.setAttribute('inert', '')
            } else {
                sibling.removeAttribute('inert')
            }
        })
    }

    setupEventListeners() {
        this.yesButton.addEventListener('click', () => this.hideAgeGate())
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new AgeGate()
})